import React from 'react';
import { useNavigate } from 'react-router-dom';

// Simple page shown when user cancels or backs out of Stripe Checkout.
const SubscriptionCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="modal-overlay" onClick={() => {
      localStorage.setItem('app-activeTab', 'profile');
      localStorage.setItem('profile-activeTab', 'subscription');
      navigate('/');
    }}>
      <div
        className="upgrade-prompt-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Upgrade Canceled</h2>
        <p className="upgrade-description">
          Your subscription was not changed. You can upgrade anytime from your profile&apos;s Subscription tab.
        </p>

        <div className="modal-actions">
          <button
            className="upgrade-btn"
            onClick={() => {
              localStorage.setItem('app-activeTab', 'profile');
              localStorage.setItem('profile-activeTab', 'subscription');
              navigate('/');
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
